import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { FormNumberField } from 'src/components/FormNumberField/FormNumberField';
import { getAdminState } from 'src/store/admin/selectors';
import { adminActions } from 'src/store/admin/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { BookingObject } from 'src/types';
import { hasCollisions } from 'src/utils/hasCollisions';

import classes from './CoordsFields.module.scss';

export interface CoordsFieldsProps {
  bookingObject: BookingObject;
}

export const CoordsFields: FC<CoordsFieldsProps> = ({ bookingObject }) => {
  const { backgroundData, bookingObjects } = useSelector(getAdminState);
  const dispatch = useAppDispatch();

  const changeX = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        adminActions.update({
          x: e.target.value ? +e.target.value : undefined,
        }),
      );
    },
    [dispatch],
  );

  const changeY = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      dispatch(
        adminActions.update({
          y: e.target.value ? +e.target.value : undefined,
        }),
      );
    },
    [dispatch],
  );

  const validateCoordinates = useCallback((): string => {
    if (
      hasCollisions(
        bookingObject,
        [...bookingObjects.values()].filter(bo => bo.id !== bookingObject.id),
      )
    )
      return 'Пересечение';
    return '';
  }, [bookingObject, bookingObjects]);

  return (
    <div className={classes.row}>
      <FormNumberField
        name='x'
        onChange={changeX}
        size='medium'
        label='X'
        min={0}
        max={backgroundData?.width}
        className={classes.halfWidth}
        dataTestId='administratorX'
        positive
        required
        integer
        validate={validateCoordinates}
      />
      <FormNumberField
        name='y'
        onChange={changeY}
        size='medium'
        label='Y'
        className={classes.halfWidth}
        dataTestId='administratorY'
        min={0}
        max={backgroundData?.height}
        positive
        required
        integer
        validate={validateCoordinates}
      />
    </div>
  );
};
